import styled from 'styled-components';

export const FeaturedShelfHeading = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  h3 {
    font-weight: 400;
  }

`;

export const FeaturedShelfArticleContainer = styled.div<{ isSingle: boolean }>`
  display: ${props => (props.isSingle ? 'block' : 'grid')};;
  --columns: 2;
  grid-template-columns: repeat(var(--columns), minmax(auto, 1fr));
  align-items: stretch;
  grid-gap: 28px;

  @media (max-width: 794px) {
      display: block;
    }

`;

export const ShelfFeaturedArticleWrapper = styled.div`
width: 100%;
text-align: left;
height: 520px;

@media (max-width: 794px) {
  margin: 2em 0 2em 0;
  height: 300px;  
  }

@media (max-width: 350px) {
    height: 200px;      
  }
`;